import { render } from "./ResponsibleMining.vue?vue&type=template&id=d1e56e74"
import script from "./ResponsibleMining.vue?vue&type=script&lang=js"
export * from "./ResponsibleMining.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__